import axios from '@/axios.js'

let entityURL = 'cron-schedule'; // variant depending on entity URLs
let token = localStorage.getItem('accessToken');
let apiEndpoint = localStorage.getItem('apiEndpoint');
axios.defaults.baseURL = apiEndpoint;
axios.defaults.headers.common = {'Authorization': `bearer ${token}`}

const state = {
    scheduleJobs: [],
    scheduleJob: {},
    xmlOptions: [],
    scenarios: [
        {id: 1, name: 'ώρα', extraStep: true},
        {id: 2, name: 'ημέρα', extraStep: true},
        {id: 3, name: 'εβδομάδα', extraStep: true},
        {id: 4, name: 'μήνας', extraStep: true},
    ],
    notificationsFromApi: [],
    jobs: [
        {
            id: 1,
            name: 'κάθε 1 ώρα',
            scenarioId: 1,
            description: 'κάθε μια (1) ώρα',
            hasDate: false,
            hasDateNumber: false,
            hasTime: false,
            hasMinute: false,
            extraStep: false,
            command: 'hourly'
        },
        {
            id: 2,
            name: 'κάθε 2 ώρες',
            scenarioId: 1,
            description: 'κάθε δυο (2) ώρες ',
            hasDate: false,
            hasDateNumber: false,
            hasTime: false,
            hasMinute: false,
            extraStep: false,
            command: 'everyTwoHours'
        },
        {
            id: 3,
            name: 'κάθε 3 ώρες',
            scenarioId: 1,
            description: 'κάθε τρεις (3) ώρες',
            hasDate: false,
            hasDateNumber: false,
            hasTime: false,
            hasMinute: false,
            extraStep: false,
            command: 'everyThreeHours'
        },
        {
            id: 4,
            name: 'κάθε 4 ώρες',
            scenarioId: 1,
            description: 'κάθε τέσσερις (4) ώρες',
            hasDate: false,
            hasDateNumber: false,
            hasTime: false,
            hasMinute: false,
            extraStep: false,
            command: 'everyFourHours'
        },
        {
            id: 5,
            name: 'Κάθε 6 ώρες',
            scenarioId: 1,
            description: 'κάθε έξι (6) ώρες',
            hasDate: false,
            hasDateNumber: false,
            hasTime: false,
            hasMinute: false,
            extraStep: false,
            command: 'everySixHours'
        },
        {
            id: 6,
            name: 'Κάθε 1 ώρα στις...',
            scenarioId: 1,
            description: 'κάθε μια ώρα στο ',
            hasDate: false,
            hasDateNumber: false,
            hasTime: false,
            hasMinute: true,
            extraStep: true,
            command: 'hourlyAt'
        },
        {
            id: 7,
            name: 'Μια φορά την εβδομάδα',
            scenarioId: 3,
            description: 'Κάθε κυριακή 00:00',
            hasDate: false,
            hasDateNumber: false,
            hasTime: false,
            hasMinute: false,
            extraStep: false,
            command: 'weekly'
        },
        {
            id: 8,
            name: 'Εβδομαδιαία ανά ημέρα και ώρα',
            scenarioId: 3,
            description: 'Μια φορά την την εβδομάδα κάθε: ',
            hasDate: true,
            hasDateNumber: false,
            hasTime: true,
            hasMinute: false,
            extraStep: true,
            command: 'weeklyOn'
        },
        {
            id: 9,
            name: 'Μια φορά την ημέρα',
            scenarioId: 2,
            description: 'Καθημερινά στης 00:00',
            hasDate: false,
            hasDateNumber: false,
            hasTime: false,
            hasMinute: false,
            extraStep: false,
            command: 'daily'
        },
        {
            id: 10,
            name: 'Μια φορά την ημέρα συγκεκριμένη ώρα',
            scenarioId: 2,
            description: 'Καθημερινά στην επιλεγμένη ώρα',
            hasDate: false,
            hasDateNumber: false,
            hasTime: true,
            hasMinute: false,
            extraStep: false,
            command: 'dailyAt'
        },
        {
            id: 11,
            name: 'Τη πρώτη μέρα κάθε μήνα',
            scenarioId: 4,
            description: 'Τη πρώτη ημέρα κάθε μήνα στις 00:00',
            hasDate: false,
            hasDateNumber: false,
            hasTime: false,
            hasMinute: false,
            extraStep: false,
            command: 'monthly',
        },
        {
            id: 12,
            name: 'Μέρα και ώρα κάθε μήνα',
            scenarioId: 4,
            description: 'Συγκεκριμένη μέρα και ώρα κάθε μήνα σύμφωνα με την επιλογή σας.',
            hasDate: false,
            hasDateNumber: true,
            hasTime: true,
            hasMinute: false,
            extraStep: false,
            command: 'monthlyOn',
        },
    ],

    cronMinutes: [
        {id: 1, name: '1', extraStep: false},
        {id: 2, name: '2', extraStep: false},
        {id: 3, name: '3', extraStep: false},
        {id: 4, name: '4', extraStep: false},
        {id: 5, name: '5', extraStep: false},
        {id: 6, name: '6', extraStep: false},
        {id: 7, name: '7', extraStep: false},
        {id: 8, name: '8', extraStep: false},
        {id: 9, name: '9', extraStep: false},
        {id: 10, name: '10', extraStep: false},
        {id: 11, name: '11', extraStep: false},
        {id: 12, name: '12', extraStep: false},
        {id: 13, name: '13', extraStep: false},
        {id: 14, name: '14', extraStep: false},
        {id: 15, name: '15', extraStep: false},
        {id: 16, name: '16', extraStep: false},
        {id: 17, name: '17', extraStep: false},
        {id: 18, name: '18', extraStep: false},
        {id: 19, name: '19', extraStep: false},
        {id: 20, name: '20', extraStep: false},
        {id: 21, name: '21', extraStep: false},
        {id: 22, name: '22', extraStep: false},
        {id: 23, name: '23', extraStep: false},
        {id: 24, name: '24', extraStep: false},
        {id: 25, name: '25', extraStep: false},
        {id: 26, name: '26', extraStep: false},
        {id: 27, name: '27', extraStep: false},
        {id: 28, name: '28', extraStep: false},
        {id: 29, name: '29', extraStep: false},
        {id: 30, name: '30', extraStep: false},
        {id: 31, name: '31', extraStep: false},
        {id: 32, name: '32', extraStep: false},
        {id: 33, name: '33', extraStep: false},
        {id: 34, name: '34', extraStep: false},
        {id: 35, name: '35', extraStep: false},
        {id: 36, name: '36', extraStep: false},
        {id: 37, name: '37', extraStep: false},
        {id: 38, name: '38', extraStep: false},
        {id: 39, name: '39', extraStep: false},
        {id: 40, name: '40', extraStep: false},
        {id: 41, name: '41', extraStep: false},
        {id: 42, name: '42', extraStep: false},
        {id: 43, name: '43', extraStep: false},
        {id: 44, name: '44', extraStep: false},
        {id: 45, name: '45', extraStep: false},
        {id: 46, name: '46', extraStep: false},
        {id: 47, name: '47', extraStep: false},
        {id: 48, name: '48', extraStep: false},
        {id: 49, name: '49', extraStep: false},
        {id: 50, name: '50', extraStep: false},
        {id: 51, name: '51', extraStep: false},
        {id: 52, name: '52', extraStep: false},
        {id: 53, name: '53', extraStep: false},
        {id: 54, name: '54', extraStep: false},
        {id: 55, name: '55', extraStep: false},
        {id: 56, name: '56', extraStep: false},
        {id: 57, name: '57', extraStep: false},
        {id: 58, name: '58', extraStep: false},
        {id: 59, name: '59', extraStep: false},
    ],
    cronDates: [
        {id: 1, value: 0, name: 'Κυριακή', extraStep: false},
        {id: 2, value: 1, name: 'Δευτέρα', extraStep: false},
        {id: 3, value: 2, name: 'Τρίτη', extraStep: false},
        {id: 4, value: 3, name: 'Τετάρτη', extraStep: false},
        {id: 5, value: 4, name: 'Πέμπτη', extraStep: false},
        {id: 6, value: 5, name: 'Παρασκευή', extraStep: false},
        {id: 7, value: 6, name: 'Σάββατο', extraStep: false},
    ],
    cronHours: [
        {id: 1, value: '00:00', extraStep: false},
        {id: 2, value: '00:30', extraStep: false},
        {id: 3, value: '01:00', extraStep: false},
        {id: 4, value: '01:30', extraStep: false},
        {id: 5, value: '02:00', extraStep: false},
        {id: 6, value: '02:30', extraStep: false},
        {id: 7, value: '03:00', extraStep: false},
        {id: 8, value: '03:30', extraStep: false},
        {id: 9, value: '04:00', extraStep: false},
        {id: 10, value: '04:30', extraStep: false},
        {id: 11, value: '05:00', extraStep: false},
        {id: 12, value: '05:30', extraStep: false},
        {id: 13, value: '06:00', extraStep: false},
        {id: 14, value: '06:30', extraStep: false},
        {id: 15, value: '07:00', extraStep: false},
        {id: 16, value: '04:30', extraStep: false},
        {id: 17, value: '08:00', extraStep: false},
        {id: 18, value: '08:30', extraStep: false},
        {id: 19, value: '09:00', extraStep: false},
        {id: 20, value: '09:30', extraStep: false},
        {id: 21, value: '10:00', extraStep: false},
        {id: 22, value: '10:30', extraStep: false},
        {id: 23, value: '11:00', extraStep: false},
        {id: 24, value: '11:30', extraStep: false},
        {id: 25, value: '12:00', extraStep: false},
        {id: 26, value: '12:30', extraStep: false},
        {id: 27, value: '13:00', extraStep: false},
        {id: 28, value: '13:30', extraStep: false},
        {id: 29, value: '14:00', extraStep: false},
        {id: 30, value: '14:30', extraStep: false},
        {id: 31, value: '15:00', extraStep: false},
        {id: 32, value: '15:30', extraStep: false},
        {id: 33, value: '16:00', extraStep: false},
        {id: 34, value: '16:30', extraStep: false},
        {id: 35, value: '17:00', extraStep: false},
        {id: 36, value: '17:30', extraStep: false},
        {id: 37, value: '18:00', extraStep: false},
        {id: 38, value: '18:30', extraStep: false},
        {id: 39, value: '19:00', extraStep: false},
        {id: 40, value: '19:30', extraStep: false},
        {id: 41, value: '20:00', extraStep: false},
        {id: 42, value: '20:30', extraStep: false},
        {id: 43, value: '21:00', extraStep: false},
        {id: 44, value: '21:30', extraStep: false},
        {id: 45, value: '22:00', extraStep: false},
        {id: 46, value: '22:30', extraStep: false},
        {id: 47, value: '23:00', extraStep: false},
        {id: 48, value: '23:30', extraStep: false},
    ],
    cronDays: [
        {id: 1, name: '1', extraStep: false},
        {id: 2, name: '2', extraStep: false},
        {id: 3, name: '3', extraStep: false},
        {id: 4, name: '4', extraStep: false},
        {id: 5, name: '5', extraStep: false},
        {id: 6, name: '6', extraStep: false},
        {id: 7, name: '7', extraStep: false},
        {id: 8, name: '8', extraStep: false},
        {id: 9, name: '9', extraStep: false},
        {id: 10, name: '10', extraStep: false},
        {id: 11, name: '11', extraStep: false},
        {id: 12, name: '12', extraStep: false},
        {id: 13, name: '13', extraStep: false},
        {id: 14, name: '14', extraStep: false},
        {id: 15, name: '15', extraStep: false},
        {id: 16, name: '16', extraStep: false},
        {id: 17, name: '17', extraStep: false},
        {id: 18, name: '18', extraStep: false},
        {id: 19, name: '19', extraStep: false},
        {id: 20, name: '20', extraStep: false},
        {id: 21, name: '21', extraStep: false},
        {id: 22, name: '22', extraStep: false},
        {id: 23, name: '23', extraStep: false},
        {id: 24, name: '24', extraStep: false},
        {id: 25, name: '25', extraStep: false},
        {id: 26, name: '26', extraStep: false},
        {id: 27, name: '27', extraStep: false},
        {id: 28, name: '28', extraStep: false},
        {id: 29, name: '29', extraStep: false},
        {id: 30, name: '30', extraStep: false},
        {id: 31, name: '31', extraStep: false},
    ],
}

const getters = {
    // Local State Data
    getMinutes: (state) => (state.cronMinutes),
    getCronScenarios: (state) => (state.scenarios),
    getCronJobs: (state) => (state.jobs),
    getCronDates: (state) => (state.cronDates),
    getCronHours: (state) => (state.cronHours),
    getCronDays: (state) => (state.cronDays),
    //Api Data
    getScheduleJobs: (state) => (state.scheduleJobs),
    getXmlOptions: (state) => (state.xmlOptions),
    getScheduleJob: (state) => (state.scheduleJob),
    getNotificationsFromApi: (state) => (state.notificationsFromApi),

}

const actions = {
    async fetchCommandOnDemand({commit},payload) {
        const response = await axios.post(`run-command`,payload)
    },

    async fetchNotifications({commit}) {
        const response = await axios(`${entityURL}/get-all-notifications`)
        let ar = []
        response.data.forEach((obj, index) => {
            let item = obj
            if (item.type.includes('ScheduleCompleted')) {
                //console.log('333')
                ar.push({
                    index    : index,
                    title    : 'Έλεγχος τιμών',
                    msg      : 'Η διαδικασία ολοκληρώθηκε με επιτυχία',
                    icon     : 'MessageSquareIcon',
                    time     : item.created_at,
                    category : 'primary'
                })

            }
            //console.log(ar)

        })
        commit('SET_NOTIFICATIONS_FROM_API', ar)

    },

    async notificationsReadAll({commit}) {
        const response = await axios(`${entityURL}/read-all-notifications`)
    },

    // Fetch all schedule jobs
    async fetchScheduleJobs({commit}) {
        const response = await axios(`${entityURL}/all`)
        commit('SET_SCHEDULE_JOBS', response.data.object)
    },

    // Fetch single schedule job
    async fetchSingleScheduleJob({commit}, payloadId) {
        const response = await axios(`${entityURL}/get/${payloadId}`)
        commit('SET_SCHEDULE_JOB', response.data.object)
    },

    async fetchXmlOptions({commit}) {
        const response = await axios(`${entityURL}/get-xml-options`)
        commit('SET_XML_OPTIONS', response.data)
    },

    // Update schedule jobs
    async updateScheduleJobs({commit}, payload) {
        const response = await axios.put(`${entityURL}/update`, payload)
        console.log( response.data)
        if( response.data.message === 'Ok') {
            commit('UPDATE_SCHEDULE_JOBS', response.data.object )
        }
    },

    // Add new cron schedule job
    async addCronScheduleJob({commit}, payload) {
        const response = await axios.post(`${entityURL}/store`, payload)
        commit('ADD_CRON_JOB', response.data.object)
    },

    // Delete cron schedule job
    async deleteCronScheduleJob({commit}, payload){
        const response = await axios.post(`${entityURL}/delete`, payload)
        if( response.data.message === 'Ok'){
            commit('DELETE_SCHEDULE_JOB', payload)
        }
    }
}

const mutations = {
    SET_SCHEDULE_JOBS: (state, data) => (state.scheduleJobs = data),
    SET_NOTIFICATIONS_FROM_API: (state, data) => (state.notificationsFromApi = data),
    SET_SCHEDULE_JOB: (state, data) => (state.scheduleJob = data),
    UPDATE_SCHEDULE_JOBS: ( state, data) => {
        let jobIndex = state.scheduleJobs.findIndex( x => x.id === data.id)
        if( jobIndex !== -1 ){
            state.scheduleJobs.splice(jobIndex, 1, data)
        }
    },
    ADD_CRON_JOB: (state, data) => (state.scheduleJobs.push(data)),
    DELETE_SCHEDULE_JOB: (state, data ) => {
        let jobIndex = state.scheduleJobs.findIndex( x => x.id === data.id)
        if( jobIndex !== -1) {
            state.scheduleJobs.splice(jobIndex, 1)
        }
    },
    SET_XML_OPTIONS: (state, data) => (state.xmlOptions = data),
}

export default {state, getters, actions, mutations}
